import { useTranslation } from 'react-i18next';

import { useQlashUser } from '@/hooks/useQlashUser';
import { BannerPicker } from '@/components/banner/BannerPicker';

/**
 * Banner page — reached by tapping the banner scroll in the Profilo
 * "Banner & Avatar" section. Hosts the full banner picker (owned banners grid +
 * "Get more banners").
 */
export function BannerSettings() {
  const { t } = useTranslation('general');
  // Una fonte sola per build: su una build Limulo Laravel non viene interrogato affatto.
  // Il perche' (e la corsa che c'era prima) in `hooks/useQlashUser.ts`.
  const me = useQlashUser();

  return (
    <div className="flex flex-col gap-6 px-4 pb-6 pt-5">
      {/* I-318, ADR-0190 §1: titolo di sezione fuori dalla vista, `sr-only`; la chiave resta in uso. */}
      <header className="sr-only">
        <h1>
          {t('banner.customize_title', { defaultValue: 'Customize banner' })}
        </h1>
      </header>
      <BannerPicker userId={me?.id} />
    </div>
  );
}
